export class OfbizFormField<T> {
    value: T;
    name: string;
    key: string;
    label: string;
    required: boolean;
    order: number;
    controlType: string;
    selectOptions: any[];
    useEditor?: boolean;

    constructor(options: {
        value?: T,
        name?: string,
        key?: string,
        label?: string,
        required?: boolean,
        order?: number,
        controlType?: string,
        selectOptions?: any[];
        useEditor?: boolean;
    } = {}) {
        this.value = options.value;
        this.name = options.name;
        this.key = options.key || '';
        this.label = options.label || '';
        this.required = !!options.required;
        this.order = options.order === undefined ? 1 : options.order;
        this.controlType = options.controlType || '';
        this.selectOptions = options.selectOptions || [];
        this.useEditor = options.useEditor || false;
    }
}

export class OfbizTexboxField extends OfbizFormField<string> {
    controlType = 'textbox';
    type: string;
    name: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || '';
    }
}

export class OfbizFileField extends OfbizFormField<string> {
    controlType = "file";
    name: string;
    type: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || '';
    }
}

export class OfbizDropdownField extends OfbizFormField<string> {
    controlType = 'dropdown';
    name: string;
    selectOptions: { key: string, value: string }[] = [];

    constructor(options: {} = {}) {
        super(options);
        this.selectOptions = options['selectOptions'] || [];
    }
}

export class OfbizCheckBoxField extends OfbizFormField<string> {
    controlType = 'checkbox';
    type: string;
    name: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || '';
    }
}

export class OfbizRadioButtonField extends OfbizFormField<string> {
    controlType = 'radio';
    options: { key: string, value: string }[] = [];
    name: string;

    constructor(options: {} = {}) {
        super(options);
        this.options = options['options'] || [];
    }
}

export class OfbizHiddenField extends OfbizFormField<string> {
    controlType = 'hidden';
    type: string;
    name: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || '';
    }

}

export class OfbizPasswordField extends OfbizFormField<string> {
    controlType = 'password';
    type: string;
    name: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || '';
    }

}

export class OfbizDisplayField extends OfbizFormField<string> {
    controlType = 'display';
    type: string;
    name: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || '';
    }
}

export class OfbizDateTimeField extends OfbizFormField<string> {
    controlType = 'datetime';
    type: string;
    name: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || '';
    }
}

export class OfbizLookupField extends OfbizFormField<string> {
    controlType = 'lookup';
    type: string;
    name: string;
    endpoint: string;
    lookupOptions: any;

    constructor(options: {} = {}) {
        super(options);
        this.endpoint = options['endpoint'] || '';
        this.lookupOptions = options['lookupOptions'] || {};
        // this.type = options['type'] || '';
    }
}

export class OfbizTexboxQBEField extends OfbizFormField<string> {
    controlType = "textqbe";
    type: string;
    name: string;
    endpoint: string;
    showDescription: boolean;
    lookupOptions: any;

    constructor(options: {} = {}) {
        super(options);
        this.endpoint = options['endpoint'] || '';
        this.showDescription = options['showDescription'] || false;
        this.lookupOptions = options['lookupOptions'] || {};
        // this.type = options['type'] || '';
    }
}

export class OfbizTextAreaField extends OfbizFormField<string> {
    controlType = "textarea";
    type: string;
    name: string;
    endpoint: string;
    useEditor: boolean;

    constructor(options: {} = {}) {
        super(options);
        this.endpoint = options['endpoint'] || '';
        this.useEditor = options["useEditor"] || false;
        // this.type = options['type'] || '';
    }
}

export class OfbizField {
    title?: string;
    name?: string;
    entryName?: string;
    action?: string;
    event?: string;
    id?: string;
    value?: string;
    required?: string;
    type: string;
    hyperlink?: any;
    parameterList?: any[];
    description?: string;
    widgetStyle?: string;
    formData?: any;
    readonly?: boolean;
    lookupOptions?: any;
}

export interface FieldSet {
    fieldSetName: string;
    fields: string[];
}

export enum FormAction {
    Find = "find",
    SELECT = "select",
    CREATE = "create",
    UPDATE = "update",
    DELETE = "delete"
}

export class OfbizForm {
    title: string;
    local: boolean;
    viewMode: string;
    layout: string;
    formAction: FormAction | string;
    formLocation: string;
    fields: OfbizField[];
    rawFields: any[];
    formName: string;
    defaultEntity: string;
    entityName?: string;
    targets?: { createTarget?: string, updateTarget?: string, findTarget?: string, deleteTarget?: string };
    appContext?: string;
    target: string;
    altTargets: any[];
    idFieldName: string;
    id: string;
    toastr: boolean;
    toastrMessage: string;
    doneUrl: string;
    state: any;
    hasFormData: boolean;
    renderComponent: any;
    titleDescriptionField: string;
    collapsible: boolean;
    fieldSets: FieldSet[];
    breadCrumbData: any;
    actionsMenu: NbMenuItem[];
    dynamicFormConditions: Condition;
    constructor(options: {
        title?: string,
        local?: boolean,
        layout?: string,
        viewMode?: string,
        formAction?: string,
        formLocation: string,
        rawFields?: any[],
        fields: OfbizField[],
        formName: string,
        entityName?: string,
        defaultEntity?: string,
        targets?: { createTarget?: string, updateTarget?: string, findTarget?: string, deleteTarget?: string },
        appContext?: string;
        target?: string,
        altTargets?: any[],
        idFieldName?: string,
        id?: string,
        toastr?: boolean,
        toastrMessage?: string,
        doneUrl?: string,
        state?: any,
        hasFormData?: boolean,
        renderComponent?: any,
        titleDescriptionField?: string;
        collapsible?: boolean;
        fieldSets?: FieldSet[],
        breadCrumbData?: any;
        actionsMenu?: NbMenuItem[];
        dynamicFormConditions?: Condition;
    } = { title: "", fields: [], formName: "", formLocation: "", breadCrumbData: {} }) {
        this.title = options.title;
        this.local = options.local;
        this.layout = options.layout;
        this.viewMode = options.viewMode;
        this.formAction = options.formAction;
        this.formLocation = options.formLocation;
        this.fields = options.fields;
        this.rawFields = options.rawFields;
        this.formName = options.formName;
        this.defaultEntity = options.defaultEntity;
        this.entityName = options.entityName,
            this.targets = options.targets;
        this.appContext = options.appContext;
        this.target = options.target;
        this.altTargets = options.altTargets;
        this.idFieldName = options.idFieldName;
        this.id = options.id;
        this.toastr = options.toastr;
        this.toastrMessage = options.toastrMessage;
        this.doneUrl = options.doneUrl;
        this.state = options.state;
        this.hasFormData = options.hasFormData;
        this.renderComponent = options.renderComponent;
        this.titleDescriptionField = options.titleDescriptionField;
        this.collapsible = options.collapsible;
        this.fieldSets = options.fieldSets;
        this.breadCrumbData = options.breadCrumbData;
        this.actionsMenu = options.actionsMenu;
        this.dynamicFormConditions = options.dynamicFormConditions
    }

    getFields(): OfbizField[] {
        return this.fields;
    }

    getFieldSets(): FieldSet[] {
        return this.fieldSets;
    }

    getLayout(): string {
        return this.layout;
    }

    isMultiPart(fields: OfbizField[]): boolean {
        console.log({ fields: fields })
        let isMultiplart: boolean = false;
        for (const field of fields) {
            // console.log({fileType:field.type});
            if (field.type == "file" || field.type == "FILE") {
                isMultiplart = true;
                break;
            }
        }
        console.log(isMultiplart)
        return isMultiplart;
    }

    getTarget(action: string): string {
        console.log("Getting the target")
        let target = null;
        console.log({ Targets: this.targets, FormName: this.formName });
        if (this.targets != undefined && this.targets != null) {
            switch (action) {
                case "add":
                    if (this.targets.createTarget) {
                        target = this.targets.createTarget
                    } else {
                        console.error("No createTarget for " + this.formName)
                    }
                    break;
                case "edit":
                    if (this.targets.updateTarget) {
                        target = this.targets.updateTarget
                    } else {
                        console.error("No updateTarget for " + this.formName)
                    }
                    break;
                case "find":
                    if (this.targets.findTarget) {
                        target = this.targets.findTarget
                    } else {
                        console.error("No findTarget for " + this.formName)
                    }
                    break;
                case "delete":
                    if (this.targets.deleteTarget) {
                        target = this.targets.deleteTarget
                    } else {
                        console.error("No deleteTarget for " + this.formName)
                    }
                    break;
                default:
                    break;
            }
        } else {
            console.error("No targets undefined for " + this.formName)
        }
        return target
    }
}

export class OfbizList {
    /* fieldFormName:string;
    fieldFormLocation:string; */
    listType: string;
    columnFieldTitles: ColumnFieldTitle[];
    fieldFormFields: OfbizField[]; // Used in find requests
    listFormName: string;
    listFormLocation: string;
    // defaultEntity:string;
    entityName: string;
    labelColumn: string; // Label used in breadCrumbs - see selectedValue
    endPoint: string;
    columnFields: OfbizField[]; // Used to create table columns
    target: string;
    appContext: string;
    altTarget: any[];
    idFieldName: string;
    id: string;
    toastr: boolean;
    toastrMessage: string;
    doneUrl: string;
    viewIndex: number;
    viewSize: number;
    linkedList: LinkedList;
    actions: any;
    findParameters: Parameter[];
    remoteFormData: RemoteFormData;
    cardMode: boolean;
    emptyListMessage: string;
    renderComponent: any;

    constructor(options: {
        listType?: string,
        columnFieldTitles: ColumnFieldTitle[],
        fieldFormName?: string,
        fieldFormLocation?: string,
        fieldFormFields?: OfbizField[],
        listFormName: string,
        listFormLocation: string,
        defaultEntity?: string,
        entityName?: string,
        labelColumn?: string,
        endPoint?: string,
        columnFields: OfbizField[],
        target?: string,
        appContext?: string,
        altTarget?: any[],
        idFieldName?: string,
        id?: string,
        toastr?: boolean,
        toastrMessage?: string,
        doneUrl?: string,
        viewIndex?: number,
        viewSize?: number,
        linkedList?: LinkedList,
        actions?: any;
        findParameters?: Parameter[],
        remoteFormData: RemoteFormData,
        cardMode?: boolean,
        emptyListMessage: string,
        renderComponent?: any
    } = {
            emptyListMessage: "",
            columnFieldTitles: [],
            columnFields: [],
            listFormName: "",
            listFormLocation: "",
            remoteFormData: {
                formData: {
                    formName: '',
                    formLocation: '',
                    listType: '',
                    entityName: '',
                    viewIndex: 0,
                    viewSize: 0
                }
            }
        }) {
        /* this.fieldFormName = options.fieldFormName,
        this.fieldFormLocation = options.fieldFormLocation,*/
        this.listType = options.listType,
            this.columnFieldTitles = options.columnFieldTitles,
            this.fieldFormFields = options.fieldFormFields,
            this.listFormName = options.listFormName,
            this.listFormLocation = options.listFormLocation,
            // this.defaultEntity = options.defaultEntity,
            this.entityName = options.entityName,
            this.labelColumn = options.labelColumn,
            this.endPoint = options.endPoint,
            this.columnFields = options.columnFields,
            this.target = options.target,
            this.appContext = options.appContext,
            this.altTarget = options.altTarget,
            this.idFieldName = options.idFieldName,
            this.id = options.id,
            this.toastr = options.toastr,
            this.toastrMessage = options.toastrMessage,
            this.doneUrl = options.doneUrl,
            this.viewIndex = options.viewIndex,
            this.viewSize = options.viewSize,
            this.linkedList = options.linkedList,
            this.actions = options.actions,
            this.findParameters = options.findParameters,
            this.remoteFormData = options.remoteFormData,
            this.emptyListMessage = options.emptyListMessage,
            this.cardMode = options.cardMode,
            this.renderComponent = options.renderComponent
    }
}

export interface ColumnFieldTitle {
    name?: string;
    title?: string;
}

export interface LinkedList {
    fieldFormName?: string,
    fieldFormLocation?: string,
    listFormName?: string,
    entityName?: string,
    listFormLocation?: string,
    endPoint?: string,
    viewIndex?: number,
    addFormOptions?: any;
    masterLinkField?: string;
    detailParameterField?: string;
    columnFields?: OfbizField[];
}

export interface Settings {
    columns: TableColumn[];
    mode?: "internal" | "inline";
    hideHeader?: boolean;
    hideSubheader?: boolean;
    noDataMessage: string;
    attr?: {
        id: string;
        class: string;
    };
    actions?: {
        columnTitle: string;
        add: boolean;
        edit: boolean;
        delete: boolean
    }
    filter?: {
        inputClass: string;
    };
    edit?: {
        inputClass: string;
        editButtonContent: string;
        saveButtonContent: string;
        cancelButtonContent: string;
        confirmSave: string
    };
    add?: {
        inputClass: string;
        addButtonContent: string;
        createButtonContent: string;
        cancelButtonContent: string;
        confirmCreate: boolean;
    };
    delete?: {
        deleteButtonContent: string;
        confirmDelete: boolean;
    };
    pager?: {
        display: boolean;
        perPage: number;
    };
    rowClassFunction?: Function
}

export interface TableColumn {
    title: string;
    class?: string;
    width?: string;
    hide?: boolean | false;
    editable?: boolean | true;
    type?: "text" | "html" | "custom";
    renderComponent?: any;
    editor?: TableEditor;
    onComponentInitFunction?: Function;
    valuePrepareFunction?: Function;
    sort?: boolean | true;
    sortDirection?: "asc" | "desc";
    compareFunction: Function;
    filter?: boolean;
    filterFunction?: Function;
}

export interface TableEditor {
    type: "text" | "textarea" | "completer" | "list" | "checkbox";
    config?: {
        true?: string;
        false?: string;
        list?: any[];
        completer?: {
            data: any[];
            searchFields: string;
            titleField: string;
            descriptionField: string;
        };

    }
}

export interface RemoteFormData {
    formData: {
        formName: string;
        formLocation: string;
        listType?: string;
        entityName?: string;
        viewIndex?: number;
        viewSize?: number;
        [key: string]: any;
    }
    endPoint?: string;
    appContext?: string;
    parameters?: {};
}

export interface Pagination {
    paginate: boolean;
    event?: string;
    numberOfpages?: number;
    highIndex?: number;
    lowIndex?: number;
    nextViewIndex?: number;
    previousViewIndex?: number;
    currentPage?: number;
    viewSize?: number;
    viewIndex?: number;
    selectedViewSize?: any;
    listSize?: number;
}

export interface Parameter {
    [key: string]: any;
}
export interface ViewCell {
    value: string | number;
    rowData: any;
}
export const lookUpRequests: any[] = [
    {
        fieldName: 'createdByUserLogin',
        entityName: 'Party',
        endPoint: 'LookupPerson'
    },
    {
        fieldName: 'localeString',
        entityName: 'Locale',
        endPoint: 'LookupLocale'
    },
    {
        fieldName: 'contentId',
        entityName: 'Content',
        endPoint: 'LookupContent'
    }
]


/* this.ofbizForm.defaultEntity = "ProductCategory";
      this.ofbizForm.target = "addProdCatalogToParty";
      this.options.formName = "EditProductCategory";
      this.options.entityName = "ProductCategory";
      this.options.formLocation = "component://dissertationsza/widget/order/CategoryForms.xml"
      //this.options.prodCatalogId = this.prodCatalog.prodCatalogId;
      this.options.type = "single"; */

import { HttpParameterCodec } from '@angular/common/http';
import { Component } from '@angular/core';
import { NbMenuItem } from '@nebular/theme';
import { number } from 'echarts';
import { Condition } from './condition-evaluator.service';

export interface HttpParamsOptions {
    /**
     * String representation of the HTTP params in URL-query-string format. Mutually exclusive with
     * `fromObject`.
     */
    fromString?: string;
    /** Object map of the HTTP params. Mutally exclusive with `fromString`. */
    fromObject?: {
        [param: string]: string | string[];
    };
    /** Encoding codec used to parse and serialize the params. */
    encoder?: HttpParameterCodec;
}
